import {
    Box,
    CrudMode,
    Checkbox,
    DataDisplay,
    Grid,
    pn,
    Stack,
    Typography,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";

import { Input } from "components";
import {  PostHighSchoolStatus, PostHSPlanStatusEditResource, PostHSPlanStatusViewResource } from "generated/openApi";
import produce from "immer";
import React from "react";

export const PostHSPlanStatusPageBody = (props: {
    crudMode: CrudMode;
    postHSPlanStatus: PostHighSchoolStatus;
    setPostHSPlanStatus: (value: PostHighSchoolStatus) => void;
    viewResource: PostHSPlanStatusViewResource;
    editResource: PostHSPlanStatusEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<PostHighSchoolStatus>("name");
        const property = properties.find((x) => x.propertyName === propertyName);
        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.postHSPlanStatus.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.postHSPlanStatus.name}
                onChange={(e) =>
                    props.setPostHSPlanStatus(
                        produce(props.postHSPlanStatus, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={largeFieldBreakpoints}>
                {nameField()}
            </Grid>
        </Grid>
    );
};